export async function registerServiceWorker(path): Promise<ServiceWorker> {
  try {
    const registration = await navigator.serviceWorker.register(path, { type: 'module' });
    return registration.installing || registration.waiting || registration.active;
  } catch (error) {
    console.log('An error has occurred while registering a ServiceWorker.');
    console.error(error);
  }
}
